// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services-section {
    text-align: center;
}

.service-card h3 {
    font-size: 1.5rem;
    margin-bottom: 20px;
    color: pink;
    -webkit-text-stroke: 1px black; /* outline thickness + color */
    font-weight: 400;
}

.service-list {
    display: flex;
    justify-content: center;
    gap: 40px;
    flex-wrap: wrap;
}
  
.service-card {
    width: 250px;
    padding: 20px;
    border: 1px solid #eee;
    border-radius: 10px;
}`, "",{"version":3,"sources":["webpack://./src/Sections/Services/Services.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,8BAA8B,EAAE,8BAA8B;IAC9D,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB","sourcesContent":[".services-section {\n    text-align: center;\n}\n\n.service-card h3 {\n    font-size: 1.5rem;\n    margin-bottom: 20px;\n    color: pink;\n    -webkit-text-stroke: 1px black; /* outline thickness + color */\n    font-weight: 400;\n}\n\n.service-list {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n    flex-wrap: wrap;\n}\n  \n.service-card {\n    width: 250px;\n    padding: 20px;\n    border: 1px solid #eee;\n    border-radius: 10px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
